import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import DstButton from "../../components/DstButton/DstButton";
import DstLiveTable from "../../components/DstTable/DstLiveTable";
import { useSession } from "../../contexts/SessionContext";
import { PermissionComponent } from "../../services/PermissionGuard";
import { formatDateHumanly } from "../../services/TimeService";
import translate from "../../services/Translate";
import PermissionsApiKeyCreationModal from "./components/CreationModal/CreationModal";

const PermissionsApiKey = () => {
  const { language } = useSession();
  const navigate = useNavigate();
  const [showModalCreation, setShowModalCreation] = useState(false);
  const [tableKey, setTableKey] = useState(0);

  const refreshTable = () => {
    setTableKey((prev) => prev + 1);
  };

  const columns = [
    {
      key: "id",
      name: translate(language, "GLOBAL.ID"),
      sortable: true,
    },
    {
      key: "name",
      name: translate(language, "GLOBAL.NAME"),
      sortable: true,
    },
    {
      key: "code",
      name: translate(language, "PAGES.PERMISSIONS_API_KEY.FIELDS.CODE"),
      sortable: true,
    },
    {
      key: "description",
      name: translate(language, "GLOBAL.DESCRIPTION"),
    },
    {
      key: "dt_created",
      name: translate(language, "PAGES.PERMISSIONS_API_KEY.FIELDS.CREATED_AT"),
      render: (item: any) => formatDateHumanly(language, item.dt_created, true),
      sortable: true,
    },
    {
      key: "dt_updated",
      name: translate(language, "PAGES.PERMISSIONS_API_KEY.FIELDS.UPDATED_AT"),
      render: (item: any) => (item.dt_updated ? formatDateHumanly(language, item.dt_updated, true) : "-"),
      sortable: true,
    },
    {
      key: "dt_expiration",
      name: translate(language, "PAGES.PERMISSIONS_API_KEY.FIELDS.EXPIRATION"),
      render: (item: any) => (item.dt_expiration ? formatDateHumanly(language, item.dt_expiration, true) : "–"),
      sortable: true,
    },
    {
      key: "role",
      name: translate(language, "PAGES.PERMISSIONS_API_KEY.FIELDS.ROLE"),
      render: (item: any) => (
        <span className="clickable electric-blue-font" onClick={() => navigate(`/permissions?role=${item.role}`)}>
          <span className="dst-icon-link-01 me-1" />
          {item.role}
        </span>
      ),
    },
  ];

  return (
    <div className="px-3 pt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="mb-0">{translate(language, "PAGES.PERMISSIONS_API_KEY.TITLE")}</h1>
        <PermissionComponent neededPermission={[{ methods: ["POST"], route: "/api-keys" }]}>
          <DstButton
            value={translate(language, "PAGES.PERMISSIONS_API_KEY.BUTTONS.CREATE_API_KEY")}
            btnImageBefore={<span className="me-2 dst-icon-plus" />}
            clickFunction={() => setShowModalCreation(true)}
          />
        </PermissionComponent>
      </div>
      <PermissionsApiKeyCreationModal
        show={showModalCreation}
        closeModal={() => {
          setShowModalCreation(false);
          refreshTable();
        }}
        language={language}
      />
      <DstLiveTable key={tableKey} columns={columns} remote="api-keys" remoteKey="api_keys" pagination />
    </div>
  );
};

export default PermissionsApiKey;
